/**
 * 自定义全局方法
 * */
import Vue from 'vue'
import jsonp from 'jsonp'
import Config from '@/config/index'
import Api from '@/api/index'
import wxShareInfo from '@/public/wxShare' //初始化wx 每次转跳必须初始化一次
import sc from '@/public/scClass'
// const aes = require('../assets/js/aes.js')
// const ecb = require('../assets/js/mode-ecb.js')
export default{
  install(Vue,options)
  {
    Vue.prototype.$getData = function () {
    }
    Vue.prototype.$jsonp = jsonp
    Vue.prototype.$config = Config
    Vue.prototype.$api = new Api()
    Vue.prototype.$wxShareInfo = wxShareInfo
    Vue.prototype.$sa = new sc()
    // Vue.prototype.$aes = function aesDecry(data){
    //   var key = CryptoJS.enc.Utf8.parse('YiYangKeJi++++++')
    //   var encryptedHexStr = CryptoJS.enc.Hex.parse(data);
    //   var encryptedBase64Str = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    //   var decryptedData = CryptoJS.AES.decrypt(encryptedBase64Str, key, {
    //     mode: CryptoJS.mode.ECB,
    //     padding: CryptoJS.pad.Pkcs7
    //   });
    //
    //   return decryptedData.toString(CryptoJS.enc.Utf8);
    // }
  }
}



// WEBPACK FOOTER //
// ./src/plugin/index.js